export default (
  <svg width="12" height="12" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 7V10H8V7H9ZM4 0V10H5V0H4ZM0 3V10H1V3H0Z" fill="var(--text_color)" />
  </svg>
)
